@if(nevvonId){
  <div class="tile">
    <p class="summary-heading">Access Your Training</p>
    <div class="button-container no-padding no-margin">
      <a
        (click)="handleRedirect($event)"
        class="view-welcome-letter btn btn-info"
        target="_blank"
      >
        View
      </a>
    </div>
  </div>
}